import BillboardsContract from '../../../lib/billboards-contract';

const updateBillboards = async () => {
  const contract = new BillboardsContract();
  const res = await contract.getState();
  return res;
};

export const getBillboards = async () => {
  const state = await updateBillboards();
  return { state };
};

export const bid = async (params) => {
  const { value, text } = params;
  const contract = new BillboardsContract();
  const res = await contract.bid(value, text);
  console.log(`actions.bid: ${res}`);
  return { res };
};

export const acceptBid = async () => {
  const contract = new BillboardsContract();
  const res = await contract.acceptBid();
  console.log(`actions.acceptBid: ${res}`);
  return { res };
};

export const renew = async () => {
  const contract = new BillboardsContract();
  const res = await contract.renew();
  console.log(`actions.renew: ${res}`);
  return { res };
};

export const toggleInfo = toggle => ({ toggle });



// WEBPACK FOOTER //
// ./src/store/billboards/data/actions.js